import React from 'react';
import Grid from '@material-ui/core/Grid';
import {Styles} from '../../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import clsx from "clsx";
import {DataTableLocalization, Translate} from "../../../../../config/Translate";
import axios from "axios";
import {defaultVariabls} from "../../../../../config/index";
import {connect, getStore} from "trim-redux";
import MaterialTable from "material-table";
import {tableIcons} from "../../../../../config/design/TableIcons";
import Button from "@material-ui/core/Button/Button";
import {Link, withRouter} from 'react-router-dom';
import AddBox from "@material-ui/icons/AddBox";
import { withSnackbar } from 'notistack';
import {rolesWithName, RWN, TableCount, TablePage} from "../../../../../config/Permissions";
import moment from "jalali-moment";
import Container from "@material-ui/core/Container/Container";
import Typography from "@material-ui/core/Typography/Typography";
import FilterListRoundedIcon from '@material-ui/icons/FilterListRounded';
import MenuItem from "@material-ui/core/MenuItem/MenuItem";
import AppCardLoaderTable from "../../../../components/Skeletons/AppCardLoaderTable";
import IconButton from "@material-ui/core/IconButton/IconButton";
import withWidth from "@material-ui/core/withWidth/withWidth";
import TextField from "@material-ui/core/TextField/TextField";
import ChevronLeftRoundedIcon from '@material-ui/icons/ChevronLeftRounded';
import GetAppRoundedIcon from '@material-ui/icons/GetAppRounded';
import Feature from "../../../../components/elements/Feature";


class Users extends React.Component {
    constructor(props) {
        super(props)
        this.tableRef = React.createRef()
    }
    classes = this.props.classes;
    fixedHeightPaper = clsx(this.classes.paper, this.classes.fixedHeight);
    role = this.props.match.params.role;
    state = {
        columns: [
            {
                field: 'url',
                editable: 'never',
                title: Translate.image,
                render: rowData => <img alt="avatar" src={rowData.url} className={this.classes.FMThumbnail}/>
            },
            { title: Translate.userName, field: 'name', editable: 'never' },
            { title: Translate.email, field: 'email', editable: 'never' },
            {
                title: Translate.role,
                field: 'role',
                lookup: RWN(),
            },
            {
                field: 'shop',
                editable: 'never',
                title: Translate.shopName,
                hidden: !this.props.features.marketplace
            },
            {
                field: 'confirmed',
                editable: 'never',
                title: Translate.confirmationStatus,
                lookup: {
                    "uncompleted" :
                        <Typography color="textSecondary">{Translate.uncompleted}</Typography>
                    , "confirmed":
                        <Typography style={{color: "#38bf84"}}>{Translate.confirmed}</Typography>
                    , "pending":
                        <Typography  style={{color: "#bfb20d"}} >{Translate.pending}</Typography>
                },
            },
            {
                title: Translate.registerDate,
                editable: 'never',
                field: 'created_at',
                render: rowData =>
                    <Typography className="date_in_table">
                        {`${moment(rowData.created_at).locale('fa').fromNow()}`}
                        <br/>
                        {`${moment(rowData.created_at).locale('fa').format( 'HH:mm , YYYY/M/D')}`}
                    </Typography>
            },
            { title: Translate.activity,
                editable: 'never',
                field: 'activity',
                render: rowData =>
                    <Button
                        variant="outlined"
                        color="primary"
                        component={Link}
                        to={`/manage/user/${rowData.id}`}
                        endIcon={<ChevronLeftRoundedIcon/>}
                        size={"small"}
                        style={{marginBottom:5,marginRight:5}}
                    >
                        {Translate.details}
                    </Button>
            },

        ],
        data: [],
        loading:false,
        role:"all",
        ChangeLoader:false
    };
    componentDidMount(){
        this.loadData();
    }
    async componentDidUpdate(newProps){
        if(newProps !== this.props){
            let newRole = this.props.match.params.role;
            await this.setState({
                role:!!newRole ? newRole : "all",
                ChangeLoader:true
            })
            await this.loadData();
        }
    }
    loadData(){
        this.tableRef.current && this.tableRef.current.onQueryChange()
    }
    onDeleteUser(id,hasNotif = true) {
        let data = new FormData();
        data.append('id', id);
        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        axios.post(`${defaultVariabls.url}/removeUser`, data, config)
            .then(response => {
                if(hasNotif){
                    this.props.enqueueSnackbar(Translate.deleteData, {
                        variant: 'success',
                    });
                }
                this.loadData();
                return true
            })
            .catch(error => {
                this.props.enqueueSnackbar(Translate.deleteDataFailed, {
                    variant: 'error',
                });
                this.loadData();
                return false
            });
    }
    onEditUser(user) {
        let authUser = getStore().user;
        if(authUser.role.permission.manageSettings){
            let data = new FormData();
            data.append('id', user.id);
            data.append('role', user.role);
            let loginToken = localStorage.getItem('ACT');

            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            axios.post(`${defaultVariabls.url}/quickEditUser`, data, config)
                .then(response => {
                    this.props.enqueueSnackbar(Translate.detailsSet, {
                        variant: 'success',
                    });
                    this.loadData();
                    return true
                })
                .catch(error => {
                    console.log(error.response)
                    this.props.enqueueSnackbar(Translate.detailsSetFailed, {
                        variant: 'error',
                    });
                    return false
                });
        }else{
            this.props.enqueueSnackbar(Translate.youDontHavePermission, {
                variant: 'error',
            });
            this.loadData();
        }

    }

    async handleChangeRole(e) {
        this.setState({
            ChangeLoader:true
        })
        let target = e.target;
        let role = target.value;
        await this.setState({
            role
        });
        this.props.history.push(`/manage/users/view/${role}`)

        this.loadData();
    }

    render(){
        let loginToken = localStorage.getItem('ACT');
        let {role} = this.state;
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        const data = new FormData();
        data.append('role', role);
        return (
                <>
                    {
                        this.state.loading ? <AppCardLoaderTable/> :
                            <Container maxWidth="xl">
                                <Grid container spacing={2}>
                                    <Grid item xs={12} >
                                        <Grid container spacing={2} direction="row" className={this.classes.filterContainer}>
                                            <Grid item xs={12} md={3} lg={1}>
                                                <Typography>
                                                    <FilterListRoundedIcon/>
                                                    {Translate.filters}:
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} md={3} lg={2}>
                                                <TextField
                                                    select
                                                    fullWidth
                                                    value={role}
                                                    onChange={this.handleChangeRole.bind(this)}
                                                    >
                                                        {
                                                            rolesWithName().map((row,index) => (
                                                                    <MenuItem key={index} value={row.value}>{row.name}</MenuItem>
                                                            ))
                                                        }
                                                        <MenuItem value='all'>{Translate.allRoles}</MenuItem>
                                                    </TextField>
                                            </Grid>
                                            <Feature check="export_users">
                                            <Grid item xs={12} md={3} lg={2}>
                                                <Button
                                                    variant="outlined"
                                                    color="primary"
                                                    startIcon={<GetAppRoundedIcon/>}
                                                    onClick={
                                                        () =>
                                                            window.open(`${defaultVariabls.website}/export-users`)
                                                    }

                                                >
                                                    {Translate.exportUsersList}
                                                </Button>
                                            </Grid>
                                            </Feature>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <MaterialTable
                                            parentChildData={(row, rows) => rows.find(a => a.id === row.parentId)}
                                            tableRef={this.tableRef}
                                            icons={tableIcons}
                                            title={
                                                <Link to='/manage/users/add'>
                                                    {
                                                        this.props.width !== "xs" ?
                                                            <Button
                                                                variant="contained"
                                                                color="primary"
                                                                startIcon={<AddBox/>}
                                                            >
                                                                {Translate.addUser}
                                                            </Button>
                                                            :
                                                            <IconButton color="primary">
                                                                <AddBox/>
                                                            </IconButton>
                                                    }
                                                </Link>
                                            }

                                            localization={DataTableLocalization}
                                            columns={this.state.columns}
                                            data={query =>
                                                new Promise((resolve, reject) => {
                                                    axios.post(`${defaultVariabls.url}/getUsers/withFilter?page=${query.page + 1}&per_page=${query.pageSize}&search=${query.search}`,data, config)
                                                        .then(response => {
                                                            let data = [];
                                                            // eslint-disable-next-line
                                                            response.data.data.map((row) => {
                                                                data.push({
                                                                    name: row.first_name+" "+row.last_name,
                                                                    email: row.email,
                                                                    role: !!row.role ? row.role.name : null,
                                                                    url: `${defaultVariabls.uploads}/FileManager/${row.avatar.name}_small.${row.avatar.extension}`,
                                                                    id: row.id,
                                                                    confirmed:row.confirmed,
                                                                    manager: row.manager,
                                                                    shop: !!row.shops[0] ? row.shops[0].name : null,
                                                                    created_at:row.created_at
                                                                })
                                                            });
                                                            resolve({
                                                                data: data,
                                                                page: response.data.current_page - 1,
                                                                totalCount: response.data.total,
                                                            })
                                                        }).catch(error => {
                                                        console.log(error)
                                                    })
                                                })
                                            }
                                            options={{
                                                pageSize: TablePage,
                                                pageSizeOptions: TableCount,
                                                sorting:false,
                                                draggable:false,
                                            }}

                                            editable={{
                                                onRowUpdate: (newData, oldData) =>
                                                    new Promise(resolve => {
                                                        setTimeout(() => {
                                                            resolve();
                                                            this.onEditUser(newData);
                                                            if (oldData) {
                                                                this.setState(prevState => {
                                                                    const data = [...prevState.data];
                                                                    data[data.indexOf(oldData)] = newData;
                                                                    return { ...prevState, data };
                                                                });
                                                            }
                                                        }, 600);
                                                    }),
                                                onRowDelete: oldData =>
                                                    new Promise(resolve => {
                                                        setTimeout(() => {
                                                            resolve();
                                                            this.onDeleteUser(oldData.id);
                                                            this.setState(prevState => {
                                                                const data = [...prevState.data];
                                                                data.splice(data.indexOf(oldData), 1);
                                                                return { ...prevState, data };
                                                            });
                                                        }, 600);
                                                    }),
                                            }}

                                        />
                                    </Grid>
                                </Grid>
                            </Container>
                    }
                </>
        );
    }
}
const mstp = state => ({
    features: state.features
});
export default  withWidth()(withSnackbar(withRouter(withStyles(Styles)(connect(mstp)(Users)))));

